module.exports = __webpack_public_path__ + "static/media/TicketImg.76f82453.jpg";